import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b00f456"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title__inner" }
const _hoisted_2 = { class: "subtitle__inner" }

import { IonItem, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, } from '@ionic/vue';
import { TPlace } from '@/const/types/place';

interface Props {
    place: TPlace;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ArticlePlaceCardBase',
  props: {
    place: null
  },
  setup(__props: any) {

const props = __props as {
    place: TPlace;
};




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), { class: "ion-no-padding" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCard), { class: "card__outer" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardHeader), { class: "card__header" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCardTitle), { class: "title__outer" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("span", null, _toDisplayString(props.place.name), 1)
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonCardSubtitle), { class: "subtitle__outer" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", null, _toDisplayString(props.place.code), 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})